module.exports = __webpack_public_path__ + "img/Team-YanaFayer.d8c5e90f.png";